export default __webpack_public_path__ + "static/do-position-37f0899b7882f0605858653d851fd1bd.png";